export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number,
  immediate: boolean = false
) {
  let timeout: ReturnType<typeof setTimeout> | null = null
  let pending: (() => void) | null = null

  const debounced = function (
    this: ThisParameterType<T>,
    ...args: Parameters<T>
  ): void {
    pending = () => func.apply(this, args)

    const callNow = immediate && timeout === null

    if (timeout !== null) {
      clearTimeout(timeout)
    }

    timeout = setTimeout(() => {
      timeout = null
      if (!immediate) {
        func.apply(this, args)
      }
    }, wait)

    if (callNow) {
      func.apply(this, args)
    }
  }

  debounced.flush = () => {
    if (timeout !== null) {
      clearTimeout(timeout)
      timeout = null
      pending?.()
    }
  }

  return debounced
}
